import { z } from 'zod';

// TODO: We can make this more well defined if we want to down the line, once params for compliance controller are finalized
export const ComplianceControllerDataSchema = z.record(
  z.union([z.string(), z.boolean()]),
);

export type ComplianceControllerData = z.infer<
  typeof ComplianceControllerDataSchema
>;
